<!--
 * 打码排行榜
-->
<template>
  <div class="rank-wrap">
    <div class="tab-wrap" v-if="showTab">
      <div class="tab" :class="{ active: active === 1 }" @click="handleTab(1)">
        {{ $t("Datalang.home_Individual_leaderboard") }}
      </div>
      <div class="tab" :class="{ active: active === 2 }" @click="handleTab(2)">
        {{ $t("Datalang.home_Team_leaderboard") }}
      </div>
    </div>
    <div class="rank_content">
      <el-row class="rankRow mt20" :gutter="12">
        <el-col :span="IsMobile ? 24 : 9">
          <div class="rankColMain rankCol1">
            <img
              class="jiangbei"
              v-if="active === 1 || (active === 2 && Number(dataObj.rewardType) === 2)"
              :src="jiangbei"
              alt
            />
            <img class="jiangbei" v-else :src="tuandui" alt />
            <div class="rc-wrap">
              <div class="rc1Con1">
                <img class="maisui" :src="maisui1" alt />
                <span class="" v-if="active === 1 || (active === 2 && Number(dataObj.rewardType) === 2)">{{
                  $t("Datalang.newly_Current_Prize")
                }}</span>
                <span class="" v-else>{{ $t("Datalang.home_Team_highest") }}</span>
                <img class="maisui" :src="maisui2" alt />
              </div>
              <div class="rc1Con2">
                {{ coinSymbol }}&nbsp;{{ divideAccuracy(dataObj.rewardPool, coinAccuracy, "point") }}
              </div>
              <div class="view-tuandui" @click="showTuandui2" v-if="active === 2 && Number(dataObj.rewardType) === 1">
                {{ $t("Datalang.home_View_all") }}
              </div>
            </div>
            <div class="rc1Con3 help" @click="PopupWindowShow = true">
              <span>?</span>
            </div>
          </div>
        </el-col>
        <el-col :span="IsMobile ? 11 : 7">
          <div class="rankColMain rankCol2">
            <div class="rc2Con1">
              {{
                dataObj.displayNextCycle === "STATUS_BOOL_TRUE"
                  ? $t("Datalang.newly_stars_next")
                  : $t("Datalang.newly_payout_countdown")
              }}
            </div>
            <div class="rc2Con2">
              <div class="rc2Con2Main" :align="'center'">
                <div class="rcTime">{{ surplusHour }}</div>
                <div class="rcTimeType">{{ $t("Datalang.Withdrawl_TIP_hour") }}</div>
              </div>
              <div class="rc2Con2Main" :align="'center'">
                <div class="rcTime">{{ surplusMin }}</div>
                <div class="rcTimeType">{{ $t("Datalang.Withdrawl_TIP_minutes") }}</div>
              </div>
              <div class="rc2Con2Main" :align="'center'">
                <div class="rcTime">{{ surplusSec }}</div>
                <div class="rcTimeType">{{ $t("Datalang.newly_second") }}</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="IsMobile ? 13 : 8">
          <div class="rankColMain rankCol3">
            <img class="jiaobiao" :src="jiaobiao" alt />
            <img class="avatarImg avatarImg1" :src="$utils.avatarUrl(dataObj.preFirstAvatar)" alt />
            <div class="rc3ConMode">
              <div style="overflow: hidden">
                <img class="huangguan fl" :src="huangguan" alt />
                <div class="rc3Contxt1 fl">{{ $t("Datalang.newly_First_Prize") }}</div>
              </div>
              <div class="rc3Contxt2">{{ $t("Datalang.newly_Previous") }}</div>
              <div class="rc3Contxt3">
                <!-- <span class="span1">{{ $t("Datalang.Invite_TITLE_reward") }}</span>&nbsp; -->
                <span class="span2"
                  >{{ coinSymbol }}&nbsp;{{ divideAccuracy(dataObj.preReward, coinAccuracy, "point") }}</span
                >
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row v-if="taken" class="rcMain mt20" :gutter="0">
        <el-col :span="IsMobile ? 8 : 5">
          <div class="raMainCol raMainCol1">
            <img class="avatarImg" :src="$utils.avatarUrl()" alt />
            <div class="nickname">{{ userInfo.nickname }}</div>
          </div>
        </el-col>
        <el-col :span="IsMobile ? 8 : 5">
          <div class="raMainCol raMainCol2">
            <div class="raMainColLine"></div>
            <div class="c900 ellipsis">
              {{ active === 1 ? $t("Datalang.Leaderboard_myrankings") : $t("Datalang.home_Team_ranking") }}
            </div>
            <div>{{ dataObj.selfRank ? dataObj.selfRankTxt : $t("Datalang.Invite_TITLE_notonlisted") }}</div>
          </div>
        </el-col>
        <el-col :span="IsMobile ? 8 : 5">
          <div class="raMainCol raMainCol2">
            <div class="raMainColLine"></div>
            <div class="c900 ellipsis">
              {{ active === 1 ? $t("Datalang.Wallet_TITLE_validbets") : $t("Datalang.home_Team_valid") }}
            </div>
            <div>{{ coinSymbol }}&nbsp;{{ divideAccuracy(dataObj.betAmount, coinAccuracy, "point") }}</div>
          </div>
        </el-col>
        <el-col :span="IsMobile ? 24 : 9">
          <div class="raMainCol raMainCol2 raMainCol3" :class="{ IsMobile: IsMobile }">
            <div v-if="!IsMobile" class="raMainColLine"></div>
            <div class="tips c900" :title="curTips">{{ curTips }}</div>
            <div class="tuandui-btn" @click="showTuandui1" :class="{ IsMobile: IsMobile }" v-if="active === 2">
              {{ $t("Datalang.home_Team_inquiry") }}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row v-else class="rcMain rcMain1 mt20" :gutter="0">
        <el-row :span="24">
          <el-button @click="goLogin" type="primary">{{ $t("Datalang.Login_TITLE_pleaselogintocheck") }}</el-button>
        </el-row>
      </el-row>

      <!-- 个人排行榜显示 勋章入口 -->
      <el-row v-if="showMedalBox" :gutter="0" class="medal-box">
        <el-col :span="24">
          <div class="medal-list" :class="{ pc: !IsMobile }">
            <template v-if="IsMobile">
              <div class="medal-list-item" v-for="item in showMedalList" :key="item.sid">
                <img
                  class="medal-item-icon-img"
                  :src="$utils.returnImgUrl(item.isUnlocked ? item.unlockIcon : item.lockedIcon)"
                  alt
                />
              </div>
              <div class="medal-list-item more" v-if="hasMoreMedal" @click="showMedal">
                <span>{{ $t("Datalang.home_more") }}</span>
              </div>
            </template>
            <template v-else>
              <div class="medal-list-item-wrap">
                <div class="medal-list-item" v-for="item in showMedalList" :key="item.sid">
                  <img
                    class="medal-item-icon-img"
                    :src="$utils.returnImgUrl(item.isUnlocked ? item.unlockIcon : item.lockedIcon)"
                    alt
                  />
                </div>
              </div>
              <el-button class="pc-more" v-if="hasMoreMedal" @click="showMedal">
                <span>{{ $t("Datalang.home_more") }}</span>
              </el-button>
            </template>
          </div>
          <div class="medal-exchange" v-if="lastRank">
            <div class="medal-tips">{{ formatLang($t("Datalang.home_medal_redeem"), [lastRank]) }}</div>
            <div class="medal-exchange-btn" @click="showMedalExchange">{{ $t("Datalang.Task_TITLE_exchange") }}</div>
          </div>
        </el-col>
      </el-row>

      <!-- 弹窗不展示排行 -->
      <div v-if="isShowRank" class="tableTitle">
        <div class="currentBtn fl">
          <img class="benqi" :src="benqi" alt />
          <div class="benqiTxt">
            {{
              active === 1 && dataObj.displayNextCycle === "STATUS_BOOL_TRUE"
                ? $t("Datalang.newly_previous_leaderboard")
                : $t("Datalang.newly_current")
            }}
          </div>
        </div>
        <div v-if="dataObj.displayNextCycle !== 'STATUS_BOOL_TRUE'" class="prevBtn fr" @click="handleRankPrev">
          {{ $t("Datalang.newly_previous_leaderboard") }}
        </div>
      </div>
      <table v-if="isShowRank" class="table">
        <thead>
          <th :width="active === 1 ? '22%' : '16%'">{{ $t("Datalang.Invite_BTM_rankings") }}</th>
          <th :width="active === 1 ? '26%' : '21%'">
            {{ active === 1 ? $t("Datalang.Leaderboard_Player") : $t("Datalang.VIPSpin_Spin_Name") }}
          </th>
          <th :width="'21%'" v-if="active === 2">{{ $t("Datalang.home_Team_members") }}</th>
          <th :width="active === 1 ? '26%' : '21%'">{{ $t("Datalang.Wallet_TITLE_validbets") }}</th>
          <th :width="active === 1 ? '26%' : '21%'">{{ $t("Datalang.Invite_TITLE_reward") }}</th>
        </thead>
        <tbody>
          <tr v-if="!tableData.length">
            <td class="empty" :colspan="4">
              <div class="empty">
                <img src="@/assets/new/zanwu.png" alt="" />
                <div>{{ $t("Datalang.Invite_TITLE_nodatanow") }}</div>
              </div>
            </td>
          </tr>
          <tr v-else v-for="(item, index) in tableData" :key="index" :align="'center'">
            <td :width="active === 1 ? '22%' : '16%'" :class="item.rank < 4 ? 'imgTd' : ''">
              <!-- $utils.returnImgUrl -->
              <img v-if="item.rank < 4" class="tableImg" :src="require(`@/assets/rankList/${item.rank}.png`)" alt />
              <span v-else>{{ item.rank }}</span>
            </td>
            <td :width="active === 1 ? '26%' : '21%'" class="username">{{ item.username }}</td>
            <td :width="'21%'" v-if="active === 2">{{ item.teamNum }}</td>
            <td :width="active === 1 ? '26%' : '21%'">{{ divideAccuracy(item.betAmount, coinAccuracy, "point") }}</td>
            <td :width="active === 1 ? '26%' : '21%'">{{ divideAccuracy(item.reward, coinAccuracy, "point") }}</td>
          </tr>
        </tbody>
      </table>

      <div v-if="isShowRank" class="mt20" style="padding-bottom: 10px" :align="'center'">
        {{
          active === 2
            ? $t("Datalang.newly_updated_minutes")
            : `${$t("Datalang.newly_update_time")}：${dataObj.nextUpdateTime}`
        }}
      </div>

      <PopupDialog
        ref="PopupDialog"
        key="PopupDialog"
        width="500px"
        :dataOpt="{ title: $t('Datalang.Invite_TITLE_rules') }"
        :show.sync="PopupWindowShow"
        @close="PopupWindowShow = false"
      >
        <template #center>
          <div class="modal-info">
            <p class="content" v-html="dataObj.activityInfo?.content"></p>
          </div>
        </template>
      </PopupDialog>

      <PopupDialog
        ref="PopupDialogPrev"
        key="PopupDialogPrev"
        width="800px"
        :dataOpt="{ title: $t('Datalang.newly_previous_leaderboard') }"
        :show.sync="PopupWindowShowPrev"
        @close="PopupWindowShowPrev = false"
      >
        <template #center>
          <table class="table">
            <thead>
              <th>{{ $t("Datalang.Invite_BTM_rankings") }}</th>
              <th>{{ active === 1 ? $t("Datalang.Leaderboard_Player") : $t("Datalang.VIPSpin_Spin_Name") }}</th>
              <th v-if="active === 2">{{ $t("Datalang.home_Team_members") }}</th>
              <th>{{ $t("Datalang.Wallet_TITLE_validbets") }}</th>
              <th>{{ $t("Datalang.Invite_TITLE_reward") }}</th>
            </thead>
            <tbody>
              <tr v-if="!tableDataPrev.length">
                <td class="empty" :colspan="!IsMobile ? 5 : 3">{{ $t("Datalang.Invite_TITLE_nodatanow") }}</td>
              </tr>
              <tr v-else v-for="(item, index) in tableDataPrev" :key="index" :align="'center'">
                <td :class="item.rank < 4 ? 'imgTd' : ''">
                  <!-- $utils.returnImgUrl -->
                  <img v-if="item.rank < 4" class="tableImg" :src="require(`@/assets/rankList/${item.rank}.png`)" alt />
                  <span v-else>{{ item.rank }}</span>
                </td>
                <td class="username">{{ item.username }}</td>
                <td v-if="active === 2">{{ item.teamNum }}</td>
                <td>{{ divideAccuracy(item.betAmount, coinAccuracy, "point") }}</td>
                <td>{{ divideAccuracy(item.reward, coinAccuracy, "point") }}</td>
              </tr>
            </tbody>
          </table>
        </template>
      </PopupDialog>
      <PopupDialog
        ref="tuanduiPopupDialog1"
        key="tuanduiPopupDialog1"
        class="table-dialog-wrap"
        width="800px"
        :dataOpt="{ title: $t('Datalang.home_Team_details') }"
        :show.sync="PopupWindowShowtuandui1"
        @close="PopupWindowShowtuandui1 = false"
      >
        <template #center>
          <div class="select">
            <el-select
              v-model="timeCycle"
              @change="timeCycleChange"
              :placeholder="$t('Datalang.Login_TIP_pleaseselect')"
            >
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </div>
          <div class="tuandui-num">{{ $t("Datalang.home_Team_contribution") }}：{{ teamNum }}</div>
          <el-table :data="tableData2" border style="width: 100%">
            <el-table-column prop="username" :label="$t('Datalang.VIPSpin_Spin_Name')" align="center"></el-table-column>
            <el-table-column prop="userSid" :label="'ID'" align="center"></el-table-column>
            <el-table-column :label="$t('Datalang.home_Bet_contribution')" align="center">
              <template slot-scope="scope">
                <span>{{ divideAccuracy(scope.row?.betAmount, coinAccuracy, "point") }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <div class="btns">
              <el-button
                :style="`margin-right: ${$px2rem(30)}`"
                :disabled="lastDisabled"
                type="text"
                @click="lastPage"
                >{{ $t("Datalang.HomePage_BTM_previous") }}</el-button
              >
              <el-button :disabled="nextDisabled" type="text" @click="nextPage">{{
                $t("Datalang.HomePage_BTM_next")
              }}</el-button>
            </div>
          </div>
        </template>
      </PopupDialog>
      <PopupDialog
        ref="tuanduiPopupDialog2"
        key="tuanduiPopupDialog2"
        class="table-dialog-wrap"
        width="500px"
        :dataOpt="{ title: $t('Datalang.home_Reward_details') }"
        :show.sync="PopupWindowShowtuandui2"
        @close="PopupWindowShowtuandui2 = false"
      >
        <template #center>
          <el-table :data="tableData3" border style="width: 100%">
            <el-table-column prop="id" :label="$t('Datalang.home_Ranking')" align="center">
              <template slot-scope="scope">{{ scope.row?.min + " - " + scope.row?.max }}</template>
            </el-table-column>
            <el-table-column :label="$t('Datalang.Invite_TITLE_reward')" align="center">
              <template slot-scope="scope">
                <span>{{ divideAccuracy(scope.row?.reward, coinAccuracy, "point") }}</span>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </PopupDialog>
    </div>
    <!-- 勋章兑换 -->
    <MedalDialog ref="medalDialog" />
  </div>
</template>

<script>
import RankMode2 from "@/lobby_common/mixins_components/rankList/RankMode2.js";
import PopupDialog from "@/components/PopupDialog";
import MedalDialog from "@/lobby_common/components/medalDialog/index.vue";
import { Table, TableColumn } from "element-ui";
export default {
  components: {
    PopupDialog,
    MedalDialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  props: [],
  mixins: [RankMode2],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.medal-box {
  padding: 10px;
  margin-top: 10px;
  background: var(--background-700);
  border-radius: var(--radius-200);
}
.medal-list {
  display: flex;
  align-items: center;
  &.pc {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .medal-list-item-wrap {
      display: flex;
      align-items: center;
      .medal-list-item {
        margin-right: 10px;
        cursor: pointer;
      }
    }
    .pc-more {
      @include buttonPrimary;
    }
  }
  .medal-list-item {
    width: 50px;
    height: 50px;
    margin-right: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--background-2201);
    border-radius: var(--radius-200);
    border: solid 1px var(--border-color-100);
    .medal-item-icon-img {
      width: 40px;
      height: auto;
    }
    &.more {
      color: var(--font-color-1300);
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--button-100);
      > span {
        @include textOverflow(1);
      }
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
.medal-exchange {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  .medal-tips {
    padding-right: 10px;
    flex: 1;
    color: var(--font-color-900);
    font-size: 12px;
    @include textOverflow(2);
  }
  .medal-exchange-btn {
    text-decoration: underline;
    color: var(--font-color-300);
    cursor: pointer;
  }
}
.page {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
}
.tuandui-num {
  text-align: end;
  margin: 10px 0;
}
.tab-wrap {
  position: relative;
  // border-radius: var(--radius-100);
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  margin-top: 20px;
  .tab {
    min-width: 120px;
    line-height: 52px;
    text-align: center;
    color: var(--font-color-600);
    background: var(--button-400);
    cursor: pointer;
    transition: all ease 0.3s;
    padding: 0 15px;
    margin-right: 20px;
    border-radius: var(--radius-100);
    @media (max-width: 768px) {
      line-height: 28px;
      height: 28px;
      // width: 33.33%;
      font-size: 14px;
      background: var(--background-1200);
      min-width: 100px;
      padding: 0 5px;
      border-radius: var(--radius-200);
    }
    &.active {
      background: var(--button-700);
      color: var(--font-color-700);
    }
  }
}
@include customTable;
table.table {
  margin-top: 0px;
}
.table-dialog-wrap {
  ::v-deep table {
    margin-top: 0px;
  }
}

.c900 {
  color: var(--font-color-900);
}
table.table th {
  height: 44px;
  box-sizing: border-box;
  color: var(--font-color-900);
  font-size: 14px;
  font-weight: normal;
  border: none;
  background: none;
  @media (max-width: 768px) {
    height: 30px;
    font-size: 12px;
  }
}
table thead,
table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
table tbody {
  max-height: 440px;
  display: block;
  overflow: auto;
  @media (max-width: 768px) {
    max-height: 300px;
  }
}
table.table td {
  height: 44px;
  box-sizing: border-box;
  font-size: 14px;
  border: none;
  padding: 0 2px;
  @media (max-width: 768px) {
    height: 30px;
    font-size: 12px;
  }
  .tableImg {
    width: 28px;
    height: 28px;
    @media (max-width: 768px) {
      margin-top: 4px;
      width: 17px;
      height: 17px;
    }
  }
}
table.table td.imgTd {
  padding: 0 8px;
}
.avatarImg {
  width: 60px;
  height: 60px;
  @media (max-width: 768px) {
    width: 38px;
    height: 38px;
  }
}
.rank_content {
  background: var(--background-801);
  border-radius: var(--radius-300);
  @media (max-width: 768px) {
    border-radius: var(--radius-301);
  }
}
.rankRow {
  font-size: 14px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
  .el-col {
    border-radius: 5px;
    .rankColMain {
      height: 145px;
      padding: 0px 10px;
      background: var(--background-700);
      overflow: hidden;
      border-radius: 5px;
      @media (max-width: 768px) {
        height: 90px;
        margin-bottom: 10px;
      }
    }
  }
  .rankCol1 {
    position: relative;
    display: flex;
    justify-content: space-evenly;
    @media (max-width: 768px) {
      height: 130px !important;
    }
    .jiangbei {
      width: 85px;
      height: 105px;
      margin: 20px 0px 0 0px;
      @media (max-width: 768px) {
        width: 80px;
        height: 100px;
      }
    }
    .rc-wrap {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 10px 0;
    }
    .rc1Con1 {
      display: flex;
      justify-content: left;
      align-items: center;
      font-size: 16px;
      overflow: hidden;
      height: 25px;
      // margin: 10px 0 20px;
      @media (max-width: 768px) {
        font-size: 15px;
        // margin: 6px 0 16px;
      }
      .maisui {
        widows: 9px;
        height: 25px;
      }
      span {
        margin: 0 10px;
      }
    }
    .rc1Con2 {
      font-size: 22px;
      height: 50px;
      line-height: 50px;
      // max-width: 170px;
      padding: 0 35px 0 15px;
      color: var(--font-color-200);
      background: var(--background-900);
      border-radius: 5px;
      @media (max-width: 768px) {
        // max-width: 150px;
        font-size: 20px;
      }
    }
    .view-tuandui {
      font-size: 13px;
      color: var(--font-color-300);
      cursor: pointer;
    }
    .rc1Con3 {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }
  .rankCol2 {
    .rc2Con1 {
      font-size: 16px;
      color: var(--font-color-900);
      margin: 20px 0;
      text-align: center;
      @media (max-width: 768px) {
        font-size: 12px;
        margin: 9px 0;
      }
    }
    .rc2Con2 {
      display: flex;
      justify-content: center;
      .rc2Con2Main {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        width: 60px;
        height: 65px;
        border-radius: 5px;
        color: var(--font-color-100);
        background: var(--background-1200);
        margin: 0 6px;
        @media (max-width: 768px) {
          width: 50px;
          height: 50px;
          margin: 0 3px;
        }
        .rcTime {
          font-size: 30px;
          @media (max-width: 768px) {
            font-size: 20px;
          }
        }
        .rcTimeType {
          color: var(--font-color-100);
          margin-top: 5px;
        }
      }
    }
  }
  .rankCol3 {
    position: relative;
    display: flex;
    justify-content: center;
    .jiaobiao {
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
      width: 58px;
      height: 60px;
      @media (max-width: 768px) {
        width: 37px;
        height: 38px;
      }
    }
    .avatarImg1 {
      margin: 60px 20px 0 0;
      @media (max-width: 768px) {
        margin: 38px 10px 0 0;
      }
    }
    .rc3ConMode {
      margin: 30px 0 0 0;
      @media (max-width: 768px) {
        margin: 10px 0 0 0;
      }
      .huangguan {
        width: 24px;
        height: 18px;
        line-height: 24px;
        margin-right: 5px;
        @media (max-width: 768px) {
          width: 15px;
          height: 12px;
          line-height: 12px;
        }
      }
      .rc3Contxt1 {
        color: var(--font-color-900);
      }
      .rc3Contxt2 {
        margin: 17px 0;
        @media (max-width: 768px) {
          margin: 13px 0;
        }
      }
      .rc3Contxt3 {
        .span1 {
          color: var(--font-color-900);
        }
        .span2 {
          color: var(--font-color-1000);
        }
      }
    }
  }
}
.help {
  color: var(--font-color-900);
  display: inline-block;
  width: 17px;
  height: 17px;
  text-align: center;
  border-radius: 50%;
  background-color: var(--background-500);
  margin: 0 5px;
  cursor: pointer;
  @include child-center;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rcMain {
  position: relative;
  min-height: 80px;
  overflow: hidden;
  background: var(--background-700);
  margin-top: 20px;
  border-radius: 5px;
  font-size: 14px;
  @media (max-width: 768px) {
    min-height: 75px;
    margin-top: 0px;
    font-size: 12px;
  }
  .raMainCol {
    margin-top: 10px;
    @media (max-width: 768px) {
      margin-top: 8px;
    }
  }
  .raMainCol1 {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .nickname {
      max-width: calc(100% - 70px);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      @media (max-width: 768px) {
        max-width: calc(100% - 50px);
      }
    }
  }
  .raMainCol2 {
    position: relative;
    padding-left: 15px;
    height: 60px;
    line-height: 30px;
    @media (max-width: 768px) {
      height: 38px;
      line-height: 19px;
      padding-left: 5px;
    }
  }
  .raMainColLine {
    position: absolute;
    top: 10px;
    left: 0;
    width: 1px;
    height: 40px;
    background: var(--border-color-100);
    @media (max-width: 768px) {
      height: 25px;
      top: 6px;
    }
  }
  .raMainCol3 {
    position: relative;
    @media (max-width: 768px) {
      margin-top: 3px;
      height: auto;
    }
    .tips {
      padding-right: 10px;
      @media (max-width: 768px) {
        padding: 0 10px;
        text-align: center;
      }
    }
    &.IsMobile {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .tuandui-btn {
    position: absolute;
    right: 0;
    top: 10px;
    height: 36px;
    line-height: 36px;
    padding: 0 15px;
    border-radius: 5px;
    background: var(--background-400);
    cursor: pointer;
    &.IsMobile {
      position: static;
      height: 30px;
      line-height: 30px;
      text-align: center;
      min-width: 100px;
      margin: 5px auto;
    }
  }
}
.rcMain1 {
  display: flex;
  justify-content: center;
  align-items: center;
  ::v-deep button.el-button {
    height: 40px;
    @include buttonPrimary;
  }
}
.tableTitle {
  overflow: hidden;
  height: 36px;
  line-height: 36px;
  margin: 20px 0 10px 0;
  @media (max-width: 768px) {
    height: 30px;
    line-height: 30px;
    margin: 10px 0 0px 0;
  }
  .currentBtn {
    position: relative;
    .benqi {
      position: absolute;
      left: 0;
      top: 0;
      height: 36px;
      @media (max-width: 768px) {
        height: 30px;
      }
    }
    .benqiTxt {
      width: 85px;
      text-align: center;
      position: relative;
      z-index: 1;
      @media (max-width: 768px) {
        width: 75px;
      }
    }
  }
  .prevBtn {
    padding: 0 15px;
    border-radius: 5px;
    background: var(--background-400);
    cursor: pointer;
  }
}

.username {
  white-space: nowrap; /* 防止换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 使用省略号表示溢出的部分 */
}
.modal-info {
  word-break: break-word;
  overflow-wrap: break-word;
}
.empty {
  width: 100%;
  margin: 0 auto;
  margin-top: 30px;
  text-align: center;
  background: transparent;

  img {
    display: inline-block;
    width: 100px;
    height: 97px;
  }
}
</style>
